export default "__VITE_ASSET__Bq650z0T__"